import React, { PureComponent } from 'react'
import { ReactComponent as Icon } from './assets/portainer.svg'
import SvgIcon from '@material-ui/core/SvgIcon'

export default class Portainer extends PureComponent {
  render() {
    return <SvgIcon component={Icon} viewBox='0 0 354 354' />
  }
}
